import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Modal,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  selectId,
  selectLoading,
} from "./crashReportSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  checkEmptyFields,
  showDialog,
  paramsMasterAll,
  setOptionsMaster,
  formatDateTime,
  paramsStatusCrash,
  replaceNulls,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Mengimpor ikon dari react-icons

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { fetchRole, selectRole } from "../role/roleSlice";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

export const CrashReportCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataRole = useSelector(selectRole);
  const { SearchBar } = Search;

  const { id } = useParams();

  const [status, setStatus] = useState("");
  const [show, setShow] = useState(false);
  const [tableData, setTableData] = useState([]);

  const [remarks, setRemarks] = useState("");
  const paramsId = {
    crash_id: id,
  };

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    async function fetchMyAPI() {
      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      setStatus(dataId?.status);
      setRemarks(dataId?.resolved_remarks);

      const initData = dataId?.crash_report_histories.map((item, index) => {
        const newItem = replaceNulls(item);
        return {
          ...newItem,
          no: index + 1,
        };
      });

      setTableData(initData);
    }
  }, [dataId]);

  const handleSave = async () => {
    const params = {
      ...dataId,
      crash_id: id,
      status: status,
      resolved_remarks: remarks,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  // Custom change handler for status
  const handleChangeStatus = (selectedOption) => {
    const currentStatusIndex = paramsStatusCrash.findIndex(
      (status) => status.value === dataId?.status // current status
    );
    const newStatusIndex = paramsStatusCrash.findIndex(
      (status) => status.value === selectedOption.value
    );

    // Allow only one-step forward transitions or any backward transition
    if (
      newStatusIndex === currentStatusIndex + 1 ||
      newStatusIndex < currentStatusIndex
    ) {
      setStatus(selectedOption.value); // update status if valid
    } else {
      showDialog("You can only move forward by one step.");
    }
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "65px" },
    },
    {
      text: "status",
      dataField: "status",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },
    {
      text: "updated by",
      dataField: "updated_by",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
    },

    {
      text: "updated date",
      dataField: "updated_at",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "180px" },
      formatter: formatDateTime,
    },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined ? "Create Crash Report " : "Edit Crash Report "}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>

            {id !== undefined && (
              <DropdownButton
                id="dropdown-basic-button"
                title="Download Attachments"
                className="mr-3"
                variant="outline-danger" // Apply outline danger style
              >
                {dataId?.crash_report_attachments?.map((item) => {
                  return (
                    <Dropdown.Item onClick={() => window.open(item.file_path)}>
                      {item.file_name}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            )}

            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Tiket Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.ticket_code}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Username</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.username}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.name}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Summary</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.crash_summary}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Crash Details</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      as="textarea"
                      value={dataId?.crash_details}
                      disabled
                      rows={6}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Request Payload</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      as="textarea"
                      value={dataId?.request_payload}
                      rows={6}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Device Model</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.device_model}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>OS</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control type="text" value={dataId?.os} disabled />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>OS Version</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={dataId?.os_version}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Status</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      options={paramsStatusCrash}
                      value={getValueStatus(status, paramsStatusCrash)}
                      placeholder="Select ..."
                      onChange={handleChangeStatus}
                      // isDisabled={dataId?.status === "RESOLVED"}
                    />
                  </Col>
                  <Col>
                    <div
                      className="btn btn-icon btn-light btn-hover-danger btn-sm mr-3 mt-2"
                      onClick={() => {
                        setShow(true);
                      }}
                    >
                      <span className="svg-icon svg-icon-md svg-icon-secondary">
                        <i className="fa fa-info-circle"></i>
                      </span>
                    </div>
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Crash Date</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={formatDateTime(dataId?.crash_date)}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Resolved date</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={formatDateTime(dataId?.resolved_date)}
                      disabled
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Resolved Remarks</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      as="textarea"
                      onChange={(e) => setRemarks(e.target.value)}
                      value={remarks}
                      rows={4}
                      disabled={dataId?.status === "RESOLVED" ? true : false}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>
        </CardBody>
      </Card>

      <Modal
        show={show}
        size="lg"
        dialogClassName="modal-70"
        onHide={() => handleClose()} // Pindahkan logika dari handleClose ke sini
      >
        <Modal.Header closeButton>
          <Modal.Title> Report Histories </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body pt-0 mt-5" style={{ overflowY: "scroll" }}>
            <ToolkitProvider
              keyField="no"
              data={tableData}
              columns={columns}
              search
            >
              {(props) => (
                <>
                  <Row>
                    <Col></Col>
                    <Col>
                      <div className="float-right">
                        <SearchBar
                          {...props.searchProps}
                          placeholder="Search .."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div style={{ overflowY: "auto", maxHeight: "400px" }}>
                    <BootstrapTable
                      striped
                      noDataIndication="Data Not Found"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      bordered={true}
                      {...props.baseProps}
                    />
                  </div>
                </>
              )}
            </ToolkitProvider>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
